import { get } from "lodash-es";

export async function getDataFromCacheOrURL(url) {
	let response;

	console.log("LOADING", url);

	let localCacheMinutes = 5; // locally cache for 5 minutes

	if (
		window.location.href.includes("localhost") ||
		window.location.href.includes("pcochef.com")
	)
		localCacheMinutes = 15; // longer cache for localhost and pcochef.com

	let eventListTime = localStorage.getItem(`${url}-time`);

	if (eventListTime) {
		let interval = Date.now() - eventListTime;
		if (interval < 60000 * localCacheMinutes) {
			// Less than 15 minutes ago
			console.log(
				`Pulling data from cache stored ${Math.round(
					interval / 60000
				)} minutes ago`
			);
			let UpcomingServicesData = localStorage.getItem(`${url}-data`);
			if (UpcomingServicesData) response = JSON.parse(UpcomingServicesData);
		}
	}

	let fetchResponse;

	if (!response) {
		fetchResponse = await fetch(url);

		if (fetchResponse.status === 200) {
			response = await fetchResponse.json();

			localStorage.setItem(`${url}-data`, JSON.stringify(response));
			localStorage.setItem(`${url}-time`, Date.now());
		}
	}

	return [response, get(fetchResponse, "status", 200)];
}
